import { render, staticRenderFns } from "./remindDialogQCC.vue?vue&type=template&id=3412d4a5&scoped=true&"
import script from "./remindDialogQCC.vue?vue&type=script&lang=js&"
export * from "./remindDialogQCC.vue?vue&type=script&lang=js&"
import style0 from "./remindDialogQCC.vue?vue&type=style&index=0&id=3412d4a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3412d4a5",
  null
  
)

export default component.exports